import { render, staticRenderFns } from "./calendarSwitch.vue?vue&type=template&id=c9938e60&scoped=true&"
import script from "./calendarSwitch.vue?vue&type=script&lang=js&"
export * from "./calendarSwitch.vue?vue&type=script&lang=js&"
import style0 from "./calendarSwitch.vue?vue&type=style&index=0&id=c9938e60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9938e60",
  null
  
)

export default component.exports